import Axios from 'axios';

import responseHandler, { restfulResponseHandler } from './utils/responseHandler';
import errorHandler, { errorHandlerWithMessage, restfulErrorHandler } from './utils/errorHandler';

export * from './utils/URLGroup';

const BasicInstance = Axios.create({
  baseURL: '/',
  timeout: 40000,
  timeoutErrorMessage: '请求超时',
});

// restfull接口迁移用实例
const RestfulInstance = Axios.create({
  baseURL: '/',
  timeout: 20000,
  timeoutErrorMessage: '请求超时',
});

// 局域网接口接口用实例
const lanInterfaceInstance = Axios.create({
  baseURL: '/',
  timeout: 5000,
  timeoutErrorMessage: '无法连接到机器人，请检查网络连接状态',
});

BasicInstance.interceptors.response.use(responseHandler, errorHandlerWithMessage);

lanInterfaceInstance.interceptors.response.use(responseHandler, errorHandler);

RestfulInstance.interceptors.response.use(restfulResponseHandler, restfulErrorHandler);

export { RestfulInstance, lanInterfaceInstance };

export default BasicInstance;
